import { c as _c } from "react/compiler-runtime";
import { getTracking, setTracking } from "@website/store/tracking";
import { TimeSyncInitializer } from "@website/utils/time-sync-initializer";
import { GoogleTagManager } from "@website/widget/scripts/google-tag-manager";
import { Metrix } from "@website/widget/scripts/metrix";
import { Webengage } from "@website/widget/scripts/webengage";
import { useRouter } from "next/router";
import Script from "next/script";
import { FC, useEffect } from "react";
export const Scripts: FC<{
  webengageLicence?: string;
  gtmLicence?: string;
  serverNow: number;
}> = t0 => {
  const $ = _c(17);
  const {
    gtmLicence,
    serverNow,
    webengageLicence
  } = t0;
  const router = useRouter();
  let t1;
  let t2;
  if ($[0] !== router.query.app_version || $[1] !== router.query.ispwa || $[2] !== router.query.token) {
    t1 = () => {
      if (router.query.token && router.query.app_version && router.query.ispwa !== "true") {
        setTracking(_temp);
      }
      if (process.env.NEXT_PUBLIC_BUILD_ENV === "production") {
        navigator?.serviceWorker?.register("/sw.js?v=6");
      }
    };
    t2 = [router.query.app_version, router.query.ispwa, router.query.token];
    $[0] = router.query.app_version;
    $[1] = router.query.ispwa;
    $[2] = router.query.token;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Metrix />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== gtmLicence) {
    t4 = gtmLicence && <GoogleTagManager gtmId={gtmLicence} />;
    $[6] = gtmLicence;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== webengageLicence) {
    t5 = webengageLicence && <Webengage license={webengageLicence} />;
    $[8] = webengageLicence;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = getTracking().isNative && <Script src="https://web-cdn.snapp.ir/shared/scripts/super-app-api.js" strategy="afterInteractive" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== serverNow) {
    t7 = <TimeSyncInitializer serverNow={serverNow} />;
    $[11] = serverNow;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t7) {
    t8 = <>{t3}{t4}{t5}{t6}{t7}</>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
function _temp(previous) {
  return {
    ...previous,
    isNative: true
  };
}